<template>
  <div class="cloud-class" :class="{ 'is-playback': isPlayback }">
    <div class="back" v-if="isShowControls" @click="goBack">
      <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAwCAYAAAAGlsrkAAADgUlEQVRYR8XY+6ulUxzH8dcYYsglGteI/OASpsYPrkXKdRq5TogIM5Mf5D8RPx23URTygzCuTcYouSU1Ipo0buMSEWJCGPpMa9eeZ9az97P3efbxrdM5nf3s9V7ftb6Xz/dZ5H+yRQvEPQCnIb8/wdaFAAe2GidjL/yMuVmC98BRuAtHNk723VmB98T5uAIHV65z8yzA8fQ6XIAlaDL+nMVRH4JbcHpL0G7H09jQp8cnFU+PR7xu2md4Bu9hRx/grJH7vAYHVY72X7yPx/D1YDfzBe+NFViJ/N20vwr0Afw2/OF8wEfgSpxR8rMJ/REv4hVkA7vYtOATcROOrRxtACkS9+ND/FMLtEnBixHoHS35Gcg23IPvR5XjScAH4kJchn1a7vNVrMdP43pAV/C+uL3kZ+pt0/7G43gNf4yD5vNx4Hx+GO7EcZUFkyo/4OESvV2YO58ZBc59noOrcGjLigmeJ/EpsonO1gbO/5MqlyLH3HwuQbSxlL9fOtOGHqyBU31uxNktC/6O58vPbvnZdRNNcOrs9TgBOeqmfVXq7Ttt+TkN+CzcUPKzuaHc38d4FF92XXxcHqdpX4yrW/IzqfIR7isVqQ/uzqBJUYintSKfQrABLyMNvDcL+F4srayYbpKushnxulcL+G4cXlk10ZvCkECaCfhc3Iz9KvBIlU14Dr/26XI8TtpEmK1qgcfbLXhwXMeZZGPDaROlv7ZFvmTNrXiopNNE5bG2oWa+RoBHmi5D0qxpaQhpe6/PN8prJTN9N40haVaztL2kWBRjpxbYxePhZy4pRaXWJPLcG6WSTRV0o9pitPFyXIujW7xPO3yilNMd0wZX24lECNyKUyoPJMiiJgN/q0/wYK2U09tGSNls4Cm80DXoxkmfYSdy15kYLi8DdtPB5PvbZQPfjfN+EnDWSrFJr47wq5XZKJP07Gjqz0fBJwUP1orwy5R/TMuAllI7VwRgL4J+2IkM3Dn281paarRYxpeMMWk4u9i0Hg8H3UVl8s8Q3rRosg+wriny5wsegCKb0uH2bxlTI5vSYr8ZfKEvcNbLABclkwG9JhS/xbN4M/29T3DgeRWRJpNBoGYJukjjl/oGD2ARjhnYU3hqw8C6WYFz1GeWJlPL922zAsfzwQu2NcigMGxfzBI8AEXLBR6FkxE3Of3IQoCzgcBPLcGX105bFgq8W4T/B/tloBIPNqWNAAAAAElFTkSuQmCC"
      />
    </div>
    <div id="viewport" @click="togglePlay">
      <span class="play-icon" v-if="!isPlaying"></span>
    </div>

    <div class="player" v-if="isPlayback">
      <div id="toolbar" v-if="isShowControls">
        <div
          class="play-pause"
          :class="{ playing: isPlaying }"
          @click="togglePlay"
        >
          <span class="play-icon"></span>
        </div>
        <div class="played">{{ currentTime }}</div>
        <div class="scrubber" ref="scrubber" @click="seek">
          <div class="progress" :style="{ width: `${percent}%` }">
            <span class="fish"></span>
          </div>
        </div>
        <div class="duration">{{ duration }}</div>
        <select
          name="speed"
          v-model="speed"
          class="speed"
          @change="onPlaybackRateChange"
        >
          <option :value="0.5">0.5</option>
          <option :value="0.75">0.75</option>
          <option :value="1" selected>正常</option>
          <option :value="1.25">1.25</option>
          <option :value="1.5">1.5</option>
          <option :value="2">2</option>
        </select>
      </div>
    </div>

    <iframe
      v-if="!isPlayback && streamingUrl"
      :src="streamingUrl"
      frameborder="0"
      style="height: 100vh; width: 100vw"
    />
  </div>
</template>

<script>
function formatTime(time) {
  const m = Math.floor(time / 60);
  const s = Math.floor(time % 60);
  const minute = m > 9 ? m : "0" + m;
  const second = s > 9 ? s : "0" + s;
  return minute + ":" + second;
}

export default {
  components: {},
  name: "PlasoCloudClass",
  data() {
    return {
      isShowControls: true,
      timeoutId: null,
      isLoaded: false,
      currentTime: 0,
      duration: 0,
      isPlaying: false,
      player: null,
      isPlayback: false,
      streamingUrl: "",
      percent: 0,
      lastUpdateProgressAt: 0,
      startTouchPositionX: 0,
      startTouchPositionY: 0,
      startTouchTime: 0,
      touchMinHorizontalMove: 30,
      touchMaxVerticalMove: 30,
      touchWithin: 3000,
      lastUpdateProgressTime: 0,
      speed: 1,
    };
  },
  methods: {
    goBack() {
      if (this.$store.state.app) {
        this.$pub.appAction("closeAppPage");
      } else {
        this.$router.go(-1);
      }
    },
    showControls() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.isShowControls = true;
      this.timeoutId = setTimeout(() => {
        this.isShowControls = false;
      }, 3000);
    },
    onPlayerReady(player) {
      this.isLoaded = true;
      this.player = player;
    },
    togglePlay() {
      if (!this.isLoaded || !this.player) {
        return;
      }
      const player = this.player;
      const isPlaying = this.isPlaying;

      if (isPlaying) {
        player.pause().then(() => {
          this.isPlaying = false;
        });
      } else {
        if (player.ended) {
          this.player.currentTime = 0;
        }
        player.play().then(() => {
          this.isPlaying = true;
        });
      }
    },
    onPlaybackRateChange() {
      this.player.playbackRate = this.speed;
    },
    onTouchStart(event) {
      this.startTouchPositionX = event.touches[0].pageX;
      this.startTouchPositionY = event.touches[0].pageY;
      this.startTouchTime = Date.now();
      this.showControls();
    },
    onTouchEnd(event) {
      const x = event.changedTouches[0].pageX;
      const y = event.changedTouches[0].pageY;
      const endTime = Date.now();
      const moveX = x - this.startTouchPositionX;
      const moveY = y - this.startTouchPositionY;
      const elapsedTime = endTime - this.startTouchTime;
      if (
        Math.abs(moveX) < this.touchMinHorizontalMove &&
        Math.abs(moveY) > this.touchMaxVerticalMove &&
        elapsedTime < this.touchWithin
      ) {
        if (moveY < 0) {
          this.player.currentTime -= 10;
        } else {
          this.player.currentTime += 10;
        }
      }
    },
    setupTouchEvent(container) {
      container.addEventListener("touchstart", this.onTouchStart);
      container.addEventListener("touchend", this.onTouchEnd);
    },
    seek(event) {
      if (!this.isLoaded || !this.player) {
        return;
      }
      const scrubber = this.$refs.scrubber;
      const top = scrubber.getBoundingClientRect().top;
      const percent =
        (event.clientY - top) / scrubber.getBoundingClientRect().height;
      this.player.currentTime = percent * this.player.duration;
    },
    onTimeUpdate() {
      if (!this.isLoaded || !this.player) {
        return;
      }
      const currentTime = this.player.currentTime;
      this.currentTime = formatTime(currentTime);
      this.duration = formatTime(this.player.duration);
      this.percent = (this.player.currentTime / this.player.duration) * 100;
      const now = Date.now();
      const diff = now - this.lastUpdateProgressAt;
      const interval = 5 * 1000;
      if (
        this.lastUpdateProgressTime !== currentTime &&
        diff >= interval &&
        currentTime >= 1
      ) {
        this.updateProgress(currentTime);
        this.lastUpdateProgressAt = now;
        this.lastUpdateProgressTime = currentTime;
      }
    },
    updateProgress(currentTime) {
      const meetingId = this.$route.query.meetingId;
      this.$http.post("/api/app/course/class_progress", {
        meetingId,
        currentTime,
      });
    },
  },
  destroyed() {
    if (this.player) {
      this.player.pause();
      this.player = null;
    }
  },
  mounted() {
    const meetingId = this.$route.query.meetingId;

    this.$http
      .get("/api/app/course/class_info", {
        meetingId,
        appType: "liveclassSDK",
        userType: "listener",
        meetingType: "private",
        mediaType: "audio",
      })
      .then((result) => {
        const classUrl = result.class_url;
        this.isPlayback = result.is_playback;
        if (this.isPlayback) {
          const container = document.getElementById("viewport");
          container.style.display = "block";
          this.setupTouchEvent(container);
          const sdkPlayer = new window.PlasoUpimePlayer(container);
          const query = result.query;
          const option = {};
          const currentTime = result.current_time;

          sdkPlayer.setSrc(query, option);
          sdkPlayer.on("canplay", () => {
            if (currentTime) {
              sdkPlayer.currentTime = currentTime;
            }

            this.onPlayerReady(sdkPlayer);
            this.onTimeUpdate();
          });
          sdkPlayer.on("timeupdate", this.onTimeUpdate);
          sdkPlayer.on("click", this.togglePlay);
        } else {
          this.streamingUrl = classUrl;
        }
      });

    this.showControls();
  },
};
</script>
<style>
.cloud-class {
  height: 100vh;
  width: 100vw;
}
@media screen and (orientation: portrait) {
  /*要横屏显示的内容的外层盒子*/
  .is-playback {
    /* 设置基准点为左上角 */
    transform-origin: top left;
    /* 以左上角为基准点，顺时针旋转90度 然后沿Y轴反方向平移100% */
    /* 为什么沿Y轴，因为旋转使坐标轴方向发生了变化 */
    transform: rotate(90deg) translateY(-100%);
    /*设置元素的宽度为 100%父元素的高度 并提高样式优先级 */
    width: 100vh !important;
    /*设置元素的宽度为 100%父元素的宽度  并提高样式优先级 */
    height: 100vw !important;
  }
}

.player {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
}

#viewport {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  display: none;
}

#viewport .play-icon {
  position: absolute;
  top: calc(50vw - 50px);
  left: calc(50vh - 50px);
  width: 100px;
  height: 100px;
  z-index: 6;
  filter: brightness(0.8);
}

#toolbar {
  position: absolute;
  z-index: 10;
  width: 100%;
  height: 120px;
  left: 0;
  bottom: 0;
  font-size: 12px;
  display: flex;
  align-items: center;
  transform: translate(0px, 0px) translateZ(0px);
}

#toolbar::before {
  content: "";
  position: absolute;
  height: 120px;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: -1;
  pointer-events: none;
  background-image: linear-gradient(
    rgba(128, 128, 128, 0) 0%,
    rgba(115, 115, 115, 0.04) 22%,
    rgba(19, 19, 19, 0.15) 75%,
    rgba(0, 0, 0, 0.25) 100%
  );
}

.play-pause {
  width: 60px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.play-icon {
  width: 20px;
  height: 20px;
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(data:image/png;base64,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);
  transform: translate(0px, 0px) translateZ(0px);
  margin-left: 5px;
  margin-right: 5px;
}

.playing .play-icon {
  background-image: url(data:image/png;base64,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);
}

.played {
  text-align: left;
  margin-left: 5px;
  margin-right: 5px;
}

.duration {
  text-align: center;
  margin-left: 5px;
  margin-right: 5px;
}

.played,
.duration {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #ffffff;
  width: 60px;
}

.scrubber {
  flex-grow: 1;
  position: relative;
  height: 44px;
  margin: 0px;
  border-left: 0px;
  border-bottom: 0px;
  overflow: visible;
}

.scrubber::after {
  content: "";
  position: absolute;
  height: 6px;
  top: 19px;
  left: 0;
  right: 0;
  border-radius: 3px;
  border: none;
  background: rgba(255, 255, 255, 0.6);
}

.progress {
  position: absolute;
  left: 0px;
  top: calc(50% - 3px);
  height: 2vw;
  background: #03c777;
  border-radius: 3px;
  overflow: visible;
  z-index: 1;
}

.fish {
  position: absolute;
  top: -7px;
  right: -10px;
  width: 20px;
  display: inline-block;
  height: 20px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
}

.speed {
  border: none;
  outline: none;
  margin-left: 5px;
  margin-right: 5px;
}

.inlineblock {
  display: inline-block;
}

.btn {
  color: #fff;
  background-color: #2ea44f;
  border-color: rgba(27, 31, 35, 0.15);
  box-shadow: 0 1px 0 rgba(27, 31, 35, 0.1),
    inset 0 1px 0 hsla(0, 0%, 100%, 0.03);
  margin: 10px 0;
  position: relative;
  padding: 5px 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: 1px solid;
  border-radius: 6px;
  appearance: none;
}

.back {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 80px;
  text-align: center;
  transform: translate(0px, 0px) translateZ(0px);
  z-index: 20;
}

.back img {
  width: 18px;
  height: 32px;
}
</style>
